import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { Layout } from "../../ui/layout";
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import { ErrorPopup } from "../../ui/organisms/errorPopup";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { SuccessPopup } from "../../ui/organisms/successPopup";
import { ListBusinessTech } from "./list";
import { GetBusinessTechnician, resetRemoveBusinessTechnicianStatus, resetTechnicianErrors } from "./slice";

export function TecnicoAziendale() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const businessTechinician = useAppSelector(state => state.businessTechinician)

    useEffect(() => {
        dispatch(GetBusinessTechnician())
    }, []);

    useEffect(() => {
        if (businessTechinician.removeBusinessTechinicianStatus === 'successfully') {
            dispatch(GetBusinessTechnician())
        }
    }, [businessTechinician.removeBusinessTechinicianStatus])

    return (
        <Layout menuItem={MenuItems.TECNICO_AZIENDALE} breadcrumbItems={['Tecnico Aziendale']}
            headerLabel="Tecnico Aziendale"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Nuovo Tecnico Aziendale"
                        color={"orange"}
                        onClick={() => {
                            dispatch(resetTechnicianErrors())
                            navigate('/tecnicoAziendale')
                        }}
                    />
                </div>
            }
        >
            {
                (businessTechinician.removeBusinessTechinicianStatus === 'successfully' || businessTechinician.removeBusinessTechinicianStatus === 'failed') ?
                    <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                        <SuccessPopup
                            active={businessTechinician.removeBusinessTechinicianStatus === 'successfully'}
                            message="Tecnico aziendale disassociato con successo."
                            onClose={() => {
                                dispatch(resetRemoveBusinessTechnicianStatus())
                            }}
                        />
                        <ErrorPopup
                            active={businessTechinician.removeBusinessTechinicianStatus === 'failed'}
                            message="Si è verificato un errore durante il disassociamento del tecnico aziendale. Riprova."
                            onClose={() => {
                                dispatch(resetRemoveBusinessTechnicianStatus())
                            }}
                        />
                    </div>
                    : null
            }
            <ListBusinessTech />
        </Layout>
    )
}